import React, { Component } from "react";

import "./CirclePrintGiftCard.scss";
import { Button } from "@blueprintjs/core";

import CircleMeta from "../CirclePuzzleGift/CircleMeta";
import GiftCardImage from "../../styles/images/white-monday-gift-card.jpg";
import PrintableGiftCard from "./PrintableGiftcard";
import ReactToPrint from "react-to-print";

import { Translate } from "react-redux-i18n";

export default class PrintModalContent extends Component {
  render() {
    return (
      <div>
        <div className="dialog-wrapper circle-gift-card-modal">
          <CircleMeta circle={this.props.circle} />
          <div className="gift-card-form">
            <form>
              {/* <div className="gift-card-image">
                          <div className="gift-details">
                              <div className="gift-image">
                                  <CircleImage size="small" src={circle.products[0].image_url} alt={circle.products[0].name} />
                              </div>
                              <div className="gift-name">{circle.products[0].name}</div>
                              <UserDecorator userId={circle.created_by} > 
                                  <User />
                              </UserDecorator>
                          </div>
                          <div className="ihopa-details">
                              <img src={WhiteLogo} alt="ihopa - Logo" className="logo" />                                    
                              <QRCode value={circle_url} includeMargin={true} />
                          </div>
                      </div> */}
              <div className="puzzle-image">
                <img src={GiftCardImage} alt="ihopa gift card" />
              </div>

              <ReactToPrint
                trigger={() => (
                  <Button intent="primary" fill={true}>
                    <Translate value="whitemonday.print_gift_card.print_card" />
                  </Button>
                )}
                content={() => this.componentRef}
              />
              <div style={{ display: "none" }}>
                <PrintableGiftCard
                  circle={this.props.circle}
                  circleUrl={this.props.circleUrl}
                  ref={el => (this.componentRef = el)}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}
